

import { GET_ENC, POST_ENC } from "./common/EncryptedHttp";
import { BASE_URL } from "./common/const";

export const GetLanguageList = () =>
    GET_ENC(`${BASE_URL}/api/Language/GetList?`, null);

export const GetLanguageListForSelect = () =>
    GET_ENC(`${BASE_URL}/api/Language/GetListForSelect?`, null);

export const GetBranchLanguageList = (params: any) =>
    GET_ENC(`${BASE_URL}/api/Language/GetBranchLanguageList?` + params, null);

export const CreateLanguage = (data: any) =>
    POST_ENC(`${BASE_URL}/api/Language/Create`, data);

export const DeleteLanguage = (data: any) =>
    POST_ENC(`${BASE_URL}/api/Language/Delete`, data);
